import { useState } from "react";

import {
  time2String,
} from "../../../utils/utils";

export default function useHeatpumpDemoData(location) {
  const [heatpump, setHeatpump] = useState({
    id: 0,
    sg_ready_start_threshold: null,
    sg_ready_end_threshold: null,
    sg_ready_soc_threshold: 90,
    _set_point: {
      sg_ready: true,
    },
  });

  const hasBattery = location && location.inverter_set.some(i => i.battery_capacity)

  const setSgReadyTime = (lower, higher) => {
    setHeatpump((h) => ({
      ...h,
      sg_ready_start_threshold: time2String(lower),
      sg_ready_end_threshold: time2String(higher),
    }));
  };

  const setSgReadySoc = hasBattery ? (soc) => {
    setHeatpump((h) => ({
      ...h,
      sg_ready_soc_threshold: soc,
    }));
  } : null;


  return {
    heatpump,
    setSgReadySoc,
    setSgReadyTime,
    sgReadyHistory: [
      {id: 1, start_time: '2024-09-01 11:15:00', end_time: '2024-09-01 13:00:00', duration: '02:00' }
    ]
  }


}